import { Link } from 'react-router-dom';
import { IconArrowLeft } from '@tabler/icons-react';
import './NotFoundPage.scss';

export default function NotFoundPage() {
    return (
        <div className="not-found-page">
            <h1 className="not-found-page__title">Страница не найдена</h1>
            <p className="not-found-page__text">
                Такой страницы нет. Перейдите в личный кабинет или на страницу входа.
            </p>
            <div className="not-found-page__actions">
                <Link to="/" className="btn btn--primary">
                    <IconArrowLeft size={18} stroke={1.5} />
                    На главную
                </Link>
                <Link to="/login" className="btn btn--outline">Войти</Link>
            </div>
        </div>
    );
}
